(function () {
  'use strict';

  function computePoints(pence, multiplier, base) {
    var pounds = Number(pence) / 100;
    var m = Number(multiplier) > 0 ? Number(multiplier) : 1;
    var b = Number(base) > 0 ? Number(base) : 5;
    if (!isFinite(pounds) || pounds < 0) return 0;
    return Math.max(0, Math.floor(pounds * m * b));
  }
  function formatPoints(n) {
    return Number(n).toLocaleString('en-GB');
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var APP_URL = (function () {
    var s = document.querySelector('script[src*="/embed.js"]');
    return (s && s.getAttribute('data-app-url')) || 'https://club.dirtstore.co.uk';
  })();
  var SS_KEY = 'cds-points-state-v1';
  var TTL_MS = 5 * 60 * 1000;
  var state = {
    base: 5, multiplier: 1, promoActive: false,
    signedIn: false, firstName: null, pointsBalance: 0
  };

  function loadCache() {
    try {
      var raw = sessionStorage.getItem(SS_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed && parsed.t && Date.now() - parsed.t < TTL_MS) return parsed.v;
    } catch (e) { return null; }
    return null;
  }
  function saveCache(v) {
    try { sessionStorage.setItem(SS_KEY, JSON.stringify({ t: Date.now(), v: v })); } catch (e) { return; }
  }

  function fetchJson(path, opts) {
    return fetch(APP_URL + path, opts).then(function (r) { return r.ok ? r.json() : null; });
  }

  function fetchState() {
    var cached = loadCache();
    if (cached) { state = Object.assign(state, cached); return Promise.resolve(); }
    return Promise.allSettled([
      fetchJson('/api/points/config', { credentials: 'omit' }),
      fetchJson('/api/points/me', { credentials: 'include' })
    ]).then(function (results) {
      var cfg = results[0].status === 'fulfilled' ? results[0].value : null;
      var me = results[1].status === 'fulfilled' ? results[1].value : null;
      if (cfg) {
        state.base = cfg.pointsPerPoundBase || 5;
        state.multiplier = cfg.multiplier || 1;
        state.promoActive = !!cfg.promoActive;
      }
      if (me) {
        state.signedIn = !!me.signedIn;
        state.firstName = me.firstName || null;
        state.pointsBalance = me.pointsBalance || 0;
      }
      saveCache(state);
    });
  }

  function copyFor(points, useLink) {
    var pts = '<strong>' + formatPoints(points) + ' points</strong>';
    var club = useLink
      ? '<a href="' + APP_URL + '" class="cds-points__link" data-cds-open>Club Dirt Store</a>'
      : 'Club Dirt Store';
    var msg;
    if (state.signedIn) {
      var lead = state.firstName ? escapeHtml(state.firstName) + ', you' : 'You';
      msg = lead + "'ll earn " + pts + ' with ' + club;
      if (state.pointsBalance > 0) {
        msg += ' <span class="cds-points__note">&middot; you have ' + formatPoints(state.pointsBalance) + ' points</span>';
      }
    } else {
      msg = club + ' members earn ' + pts;
    }
    if (state.promoActive && state.multiplier > 1) {
      msg += ' <span class="cds-points__promo">' + state.multiplier + '&times; points</span>';
    }
    return msg;
  }

  function penceFor(el) {
    return el.getAttribute('data-club-points') === 'cart'
      ? Number(el.getAttribute('data-cart-total'))
      : Number(el.getAttribute('data-unit-price'));
  }
  function renderEl(el) {
    var pence = penceFor(el);
    if (!isFinite(pence)) return;
    var body = el.querySelector('[data-cds-body]') || el;
    var useLink = el.getAttribute('data-club-points') !== 'cart';
    body.innerHTML = copyFor(computePoints(pence, state.multiplier, state.base), useLink);
    el.removeAttribute('hidden');
  }
  function renderAll() {
    document.querySelectorAll('[data-club-points]').forEach(renderEl);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-cds-open]');
    if (!trigger) return;
    if (window.ClubDirtStore && typeof window.ClubDirtStore.open === 'function') {
      e.preventDefault();
      window.ClubDirtStore.open();
    }
  });

  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || v.price == null) return;
    var pid = e.detail.product && e.detail.product.id;
    document.querySelectorAll('[data-club-points="product"]').forEach(function (el) {
      var elPid = el.getAttribute('data-product-id');
      if (pid && elPid && String(pid) !== elPid) return;
      el.setAttribute('data-unit-price', v.price);
      renderEl(el);
    });
  });
  function refreshCart(e) {
    var cart = e.detail && e.detail.cart;
    var total = cart ? cart.total_price : null;
    document.querySelectorAll('[data-club-points="cart"]').forEach(function (el) {
      if (total != null) el.setAttribute('data-cart-total', total);
      renderEl(el);
    });
  }
  document.addEventListener('on:cart:add', refreshCart);
  document.addEventListener('on:line-item:change', refreshCart);
  document.addEventListener('on:cart-drawer:after-open', renderAll);

  function setEmbedHidden(hidden) {
    var root = document.getElementById('cds-embed-root');
    if (root) root.classList.toggle('cds-hidden', hidden);
  }
  document.addEventListener('on:cart-drawer:before-open', function () { setEmbedHidden(true); });
  document.addEventListener('on:cart-drawer:after-close', function () { setEmbedHidden(false); });

  function init() {
    renderAll();
    fetchState().then(renderAll).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
